import React from 'react';
import { Box, Heading, Text, VStack, List, ListItem, ListIcon, Image } from '@chakra-ui/react';
import { FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface ServiceSectionProps {
  imageUrl: string;
  title: string;
  description?: string;
  features?: string[];
  ctaText: string;
  ctaHref?: string;
  variant?: 'default' | 'highlighted';
}
export function ServiceSection({
  imageUrl,
  title,
  description,
  features,
  ctaText,
  ctaHref,
  variant = 'default'
}: ServiceSectionProps) {
  const highlighted = variant === 'highlighted';
  return <Box as="article" className="flame-card" bg={highlighted ? 'rgba(184, 41, 26, 0.09)' : 'rgba(20, 20, 20, 0.85)'} borderWidth="1px" borderColor={highlighted ? 'rgba(232, 99, 26, 0.4)' : 'gray.800'} borderRadius="xl" overflow="hidden" transition="transform 0.35s ease, box-shadow 0.35s ease" display="flex" flexDirection="column" _hover={{
    transform: 'translateY(-6px)',
    boxShadow: '0 18px 50px rgba(184, 41, 26, 0.32)'
  }} data-id="element-17" data-mp="1go9rn2e1gtl">
      <Box position="relative" h="190px" overflow="hidden" flexShrink={0} data-id="element-18" data-mp="d1wewu7eka2v">
        <Image src={imageUrl} alt="" w="full" h="full" htmlWidth="600" htmlHeight="190" objectFit="cover" filter="brightness(0.45) saturate(1.1)" loading="lazy" decoding="async" data-id="element-19" data-mp="hzemag5ruh8r" />
        <Box position="absolute" inset={0} bgGradient={highlighted ? 'linear(to-b, rgba(184, 41, 26, 0.15), rgba(10, 10, 10, 0.95))' : 'linear(to-b, transparent, rgba(10, 10, 10, 0.95))'} data-id="element-20" data-mp="vzh3e06996my" />
      </Box>

      <VStack spacing={5} align="stretch" p={{
      base: 6,
      md: 7
    }} flex={1} position="relative" zIndex={1} data-id="element-21" data-mp="1aolnjmwm1kxp">
        <Heading as="h3" fontSize={{
        base: 'xl',
        md: '2xl'
      }} textAlign="center" color={highlighted ? 'fire.400' : 'gold.400'} textTransform="uppercase" letterSpacing="wide" fontWeight="black" lineHeight="1.25" textShadow={highlighted ? '0 0 22px rgba(232, 99, 26, 0.55)' : '0 0 22px rgba(242, 169, 59, 0.45)'} data-id="element-22" data-mp="1flc3894i6eil">
          {title}
        </Heading>

        {description && <Text fontSize={{
        base: 'sm',
        md: 'md'
      }} color="gray.300" textAlign="center" lineHeight="tall" data-id="element-23" data-mp="13qfpor7zghdb">
            {description}
          </Text>}

        {features && features.length > 0 && <List spacing={3} data-id="element-24" data-mp="3kfuzpuwmrisq">
            {features.map(feature => <ListItem key={feature} display="flex" alignItems="flex-start" data-id="element-25" data-mp="3fhjobfqot08e">
                <ListIcon as={FlameIcon} color="fire.500" mt={1} boxSize={4} flexShrink={0} data-id="element-26" data-mp="1uxxt701lew4i" />
                <Text color="gray.200" fontSize={{
            base: 'sm',
            md: 'md'
          }} data-id="element-27" data-mp="1l96552znkvyv">
                  {feature}
                </Text>
              </ListItem>)}
          </List>}

        <CTAButton href={ctaHref} mt="auto" w="full" size="md" data-id="element-28" data-mp="1g9tiojcp1qwt">
          {ctaText}
        </CTAButton>
      </VStack>
    </Box>;
}